import React, { useContext } from 'react';
import { cloneElement } from "react";
import { getDescendantProp, lang } from '../../Utils';
import { TableContext } from './TableContext';
import { DateTime } from 'luxon';
import { FavButton } from '../../features/favourite/FavButton';
import { Tooltip } from '@chakra-ui/react';


const Body = ({ children, noDataMessage }) => {

  const context = useContext(TableContext);

  if (!!context.filteredItems && context.filteredItems.length > 0) {
    return <tbody>
      {context.filteredItems?.map((data, rIndex) => <tr key={`tr-${rIndex}`}>
        {children.map((child, cIndex) =>
          <td key={`td-${rIndex}-${cIndex}`} className={(!!child.props.className) ? child.props.className : null} onClick={() => (!!child.props.onClick) ? child.props.onClick(data) : null}>
            <div className={child.props.className}>
              <label>{child.props.label}</label>
              <div>
                {cloneElement(child, { ...child?.props, data: data }, child.children)}
              </div>
            </div>
          </td>
        )}
      </tr>)
      }
    </tbody >
  } else {
    return <tbody>
      <tr className='bf-no-data'>
        <td key={'cell-no-table-data'} colSpan={children.length}>{noDataMessage || context.noDataMessage}</td>
      </tr>
    </tbody>
  }

}

const BGeneric = (props) => <>
  {getDescendantProp(props.data, props.field)}
  {props.children}
</>

const BTranslate = (props) => <>
  {lang(getDescendantProp(props.data, props.field))}
  {props.children}
</>

const BLongText = (props) => {
  const length = props.length || 30;
  const value = getDescendantProp(props.data, props.field);
  const excerpt = (!!value && value.length > length) ? (value.substring(0, length) + ' [..]') : value;
  return (<Tooltip label={value}>
    <div>{excerpt}</div>
  </Tooltip>)
}

const BFavourite = (props) => {
  const url = getDescendantProp(props.data, props.field);
  return (!!url) ? <FavButton size="sm" attributes={{ url: url, target: '_new' }} /> : null;
}


const BBoolean = (props) => {
  const value = getDescendantProp(props.data, props.field);
  return (value) ? props.istrue : props.isfalse;
}


const BStatus = (props) => {
  const code = getDescendantProp(props.data, props.code);
  const value = lang(getDescendantProp(props.data, props.field));
  return (!!code && !!value) ? (<><span className={`bf-badge-status bf-badge-status-${code}`}>{value}</span></>) : null;
}

const BCurrency = (props) => {
  const currency = getDescendantProp(props.data, props.currency);
  const value = getDescendantProp(props.data, props.field);
  return (<>
    {new Intl.NumberFormat([], {
      style: 'currency',
      currency: currency || 'EUR',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(value)}
    {props.children}
  </>)
}

const BDate = (props) => {
  const value = DateTime.fromISO(getDescendantProp(props.data, props.field)).toLocaleString({ ...DateTime.DATE_SHORT, day: '2-digit', month: '2-digit' });
  return (<>
    {value}
    {props.children}
  </>)
}

const BComponent = (props) => {
  const RenderComponent = props.rendercomponent;
  return <RenderComponent data={props.data} />
}

const BCounter = ({ index }) => <>{index}</>;

Body.Text = BGeneric;
Body.LongText = BLongText;
Body.Favourite = BFavourite;
Body.Number = BGeneric;
Body.Currency = BCurrency;
Body.Date = BDate;
Body.Status = BStatus;
Body.Counter = BCounter;
Body.Translate = BTranslate;
Body.Component = BComponent;
Body.Boolean = BBoolean;

export { Body }